import { Link } from "react-router";
import { t } from "../i18n/sl";

/** "AI semafor" product lockup: a tiny upright semafor with the green lamp on. */
export function ProductMark({ to = "/", sub = true }: { to?: string; sub?: boolean }) {
  return (
    <Link to={to} className="product-mark" aria-label={`${t.brand.product}, ${t.brand.by}`}>
      <span className="product-mark-light" aria-hidden="true">
        <i />
        <i />
        <i className="on" />
      </span>
      <span className="product-mark-text">
        <span className="product-mark-name">{t.brand.product}</span>
        {sub && <span className="product-mark-by">{t.brand.by}</span>}
      </span>
    </Link>
  );
}
